// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "sectionWrapper-1hU8K";
var _4 = "sectionWrapper__title-BVPgS";
var _5 = "sectionWrapper__content-3oCj_";
var _6 = "sectionWrapper__error-1k37V";
var _7 = "line-2ZNuw";
var _8 = "sectionWrapper__title_wrapper-2-1Uh";
export { _1 as "__esModule", _2 as "mobile", _3 as "sectionWrapper", _4 as "sectionWrapper__title", _5 as "sectionWrapper__content", _6 as "sectionWrapper__error", _7 as "line", _8 as "sectionWrapper__title_wrapper" }
export default { "__esModule": _1, "mobile": _2, "sectionWrapper": _3, "sectionWrapper__title": _4, "sectionWrapper__content": _5, "sectionWrapper__error": _6, "line": _7, "sectionWrapper__title_wrapper": _8 }
